import {
  put,
  fork,
  call,
  takeEvery,
} from 'redux-saga/effects';
// features
import boardWatcherSaga from './features/board/sagas';
import loginWatcherSaga, { sessionSaga } from './features/auth/sagas';
// components
import fileUploadWatcherSaga from './components/app-layout/header/sagas';
// router
import {
  changeRouteRoutine,
  setPageNameRoutine,
  setCurrentRouteRoutine,
} from './router/routines';
// sagas
import { routesSagas } from './router/routes-saga';
////////////////////////////////////////////////

function* routeChangeWatcherSaga({ payload }) {
  const { name, path } = payload;

  yield call(routesSagas[path]);

  yield put(setPageNameRoutine(name));
  yield put(setCurrentRouteRoutine(path));
}

function* changeRouteRoutineSaga() {
  yield takeEvery(changeRouteRoutine, routeChangeWatcherSaga);
}

export default function* mainSaga() {
  yield [
    yield fork(changeRouteRoutineSaga),
    yield fork(loginWatcherSaga),
    yield fork(boardWatcherSaga),
    yield fork(fileUploadWatcherSaga),
  ];

  yield call(sessionSaga);
}

export {
  changeRouteRoutineSaga,
  routeChangeWatcherSaga,
};
